module.exports = __webpack_public_path__ + "static/media/mosque-in-city.c08e2417.png";